var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7896 6.41183L9.2083 4.20247M9.21042 10.4119L4.79587 8.20459M13 3.30664C13 4.41121 12.1046 5.30664 11 5.30664C9.89543 5.30664 9 4.41121 9 3.30664C9 2.20207 9.89543 1.30664 11 1.30664C12.1046 1.30664 13 2.20207 13 3.30664ZM5 7.30664C5 8.41121 4.10457 9.30664 3 9.30664C1.89543 9.30664 1 8.41121 1 7.30664C1 6.20207 1.89543 5.30664 3 5.30664C4.10457 5.30664 5 6.20207 5 7.30664ZM13 11.3066C13 12.4112 12.1046 13.3066 11 13.3066C9.89543 13.3066 9 12.4112 9 11.3066C9 10.2021 9.89543 9.30664 11 9.30664C12.1046 9.30664 13 10.2021 13 11.3066Z",
    stroke: "#123051"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueShare);
export default __webpack_public_path__ + "static/media/blueShare.55333ee192e103a30f3b46f174b7ca98.svg";
export { ForwardRef as ReactComponent };